module.exports = __webpack_public_path__ + "20240105162613/img/quanjt.36c8cd35.png";